/**
 * parentalPinGenericModal.tsx
 */
import Container from '../../atoms/container/modalContainer';
import ExtraTitle from '../../atoms/text/modalExtraTitle';
import Input from '../../elements/modal/parentalPinInput';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useCloseModalKeyboard from '@shared/components/utils/hooks/useCloseModalKeyboard';
import { modalSelector } from '@shared/store/slices/modal.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useState } from 'react';

/**
 * Displays the parental pin generic modal.
 */
export default function ParentalPinGenericModal() {
  const [error, setError] = useState(false);
  const { params } = useAppSelector(modalSelector);

  useCloseModalKeyboard({ pop: (params?.pop as boolean) || false });

  return (
    <Container>
      <Title>{TranslationManager.get('MODAL.PARENTAL_PIN.TITLE')}</Title>
      <Subtitle>
        {TranslationManager.get('MODAL.PARENTAL_PIN.GENERIC_SUBTITLE_INPUT')}
      </Subtitle>
      <Input
        allowZapping={false}
        callback={() => setError(true)}
        popRoute={false}
      />
      <ExtraTitle
        dangerouslySetInnerHTML={{
          __html: error
            ? TranslationManager.get('MODAL.PARENTAL_PIN.ERROR')
            : TranslationManager.get(
                'MODAL.PARENTAL_PIN.GENERIC_EXTRA_TITLE_INPUT'
              ),
        }}
      ></ExtraTitle>
    </Container>
  );
}
